import { trip } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getTripOptions(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.options}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(trip.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripDetails(id, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}${id}/view/`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createTripObject(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${trip.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateTripObject(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${trip.base}${id}/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateTripObject(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${trip.base}${id}/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripRoute(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}${id}/trip_routes/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripStops(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}${id}/trip_stops/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateTripAsset(tripId, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${trip.base}${tripId}/asset_change/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripOrderSummary(tripId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}${tripId}/trip_order_summary/`, {
          headers: {
            Accept: "application/xlsx",
          },
          responseType: "blob",
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripSummary(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}trip_summary/`, {
          params: params,
          headers: {
            Accept: "application/xlsx",
          },
          responseType: "blob",
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getMarkTripAsCompleteData(tripId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}${tripId}/mark_as_complete/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateMarkTripAsCompleteData(tripId, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${trip.base}${tripId}/mark_as_complete/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripLogs(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.tripLogs}`, { params: params })
        .then((res) => {
          resolve(responseHandler(res));
        })
        .catch((err) => {
          reject(errorHandler(err));
        });
    });
  },
  tiaTripRecommendation(payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}tia_recommendation/`, { params: payload })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripSheetData(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}${id}/generate_trip_sheet/`, {
          headers: { "Content-type": "application/pdf" },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripAssetInfo(tripId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}${tripId}/asset_change/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  cancelTrips(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(trip.cancel, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  rescheduleTrip(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(trip.reschedule, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTiaRecommendationUnAllocatedTrip(tripId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${trip.base}${tripId}/tia_recommendation_for_un_allocated_trips/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  retryTiaRecommendationUnAllocatedTrip(tripId) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${trip.base}${tripId}/retry_tia_recommendation_for_un_allocated_trips/`
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  acceptTiaRecommendationUnAllocatedTrip(tripId, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${trip.base}${tripId}/accept_tia_recommendation_for_un_allocated_trips/`,
          data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  assignPickupTypeOrderToOngoingTrip(trip_id, orders_id) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${trip.base}${trip_id}/assign_pickup_type_order_to_active_trip/?order_ids=${orders_id}`,
          {}
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
